let viewMoreTeam = document.querySelectorAll('.team-member');

for (let i = 0; i < viewMoreTeam.length; i++) {
  let button = viewMoreTeam[i].querySelector('.team-member__view-more-button');
  let text = viewMoreTeam[i].querySelector('.team-member__text');

  button.addEventListener('click', function() {
    text.classList.toggle('d-none');
    this.querySelector('.team-member__view-more-button--up').classList.toggle('d-none');
    this.querySelector('.team-member__view-more-button--down').classList.toggle('d-none');
  })
}



// WEBPACK FOOTER //
// ./scripts/team-members.js